import React, { useState, useEffect } from 'react';
import { createRestaurant, getRestaurant, getRestaurants } from '../../services/api'; // getRestaurants ainda não existe
import { v4 as uuidv4 } from 'uuid'; // Para gerar UUIDs no frontend, se necessário

function RestaurantManagementScreen() {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [newRestaurant, setNewRestaurant] = useState({
    NomeComercial: '',
    RazaoSocial: '',
    CNPJ: '',
    Email: '',
    Telefone: '',
    ValorMensal: 0,
    Senha: '',
    Logomarca: ''
  });

  useEffect(() => {
    fetchRestaurants();
  }, []);

  const fetchRestaurants = async () => {
    setLoading(true);
    setError('');
    try {
      // getRestaurants ainda não existe no api.js, vamos simular por enquanto
      // Em um sistema real, teríamos um endpoint GET /api/admin/restaurants
      const data = []; // await getRestaurants(); 
      setRestaurants(data);
    } catch (err) {
      setError('Failed to fetch restaurants.');
      console.error('Fetch restaurants error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRestaurant({ ...newRestaurant, [name]: value });
  };

  const handleCreateRestaurant = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // O RestaurantID será gerado no backend
      const created = await createRestaurant(newRestaurant);
      setRestaurants([...restaurants, created]);
      setNewRestaurant({
        NomeComercial: '',
        RazaoSocial: '',
        CNPJ: '',
        Email: '',
        Telefone: '',
        ValorMensal: 0,
        Senha: '',
        Logomarca: ''
      });
      alert('Restaurant created successfully!');
    } catch (err) {
      setError('Failed to create restaurant.');
      console.error('Create restaurant error:', err);
    }
  };

  if (loading) return <div>Loading restaurants...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div>
      <h2>Restaurant Management (Super Admin)</h2>

      <h3>Create New Restaurant</h3>
      <form onSubmit={handleCreateRestaurant}>
        <div>
          <label>Nome Comercial:</label>
          <input type="text" name="NomeComercial" value={newRestaurant.NomeComercial} onChange={handleInputChange} required />
        </div>
        <div>
          <label>Razão Social:</label>
          <input type="text" name="RazaoSocial" value={newRestaurant.RazaoSocial} onChange={handleInputChange} />
        </div>
        <div>
          <label>CNPJ:</label>
          <input type="text" name="CNPJ" value={newRestaurant.CNPJ} onChange={handleInputChange} required />
        </div>
        <div>
          <label>Email:</label>
          <input type="email" name="Email" value={newRestaurant.Email} onChange={handleInputChange} />
        </div>
        <div>
          <label>Telefone:</label>
          <input type="text" name="Telefone" value={newRestaurant.Telefone} onChange={handleInputChange} />
        </div>
        <div>
          <label>Valor Mensal:</label>
          <input type="number" name="ValorMensal" value={newRestaurant.ValorMensal} onChange={handleInputChange} />
        </div>
        <div>
          <label>Senha (Admin do Restaurante):</label>
          <input type="password" name="Senha" value={newRestaurant.Senha} onChange={handleInputChange} required />
        </div>
        <div>
          <label>Logomarca URL:</label>
          <input type="text" name="Logomarca" value={newRestaurant.Logomarca} onChange={handleInputChange} />
        </div>
        <button type="submit">Create Restaurant</button>
      </form>

      <h3>Existing Restaurants</h3>
      {restaurants.length === 0 ? (
        <p>No restaurants found.</p>
      ) : (
        <ul>
          {restaurants.map((restaurant) => (
            <li key={restaurant.RestaurantID}>
              {restaurant.NomeComercial} ({restaurant.CNPJ}) - ID: {restaurant.RestaurantID}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RestaurantManagementScreen;
